import type { StringKey } from '@ipfabric/utils';
import { Toggle, type ToggleProps } from 'components/Toggle/Toggle';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';
import type { NestedFormikName } from 'utils/formik/nestedFormikName';

type Props<TFormikValues> = Omit<ToggleProps, 'value' | 'onChange'> & {
  formik: FormikProps<TFormikValues>;
  name: StringKey<TFormikValues> | NestedFormikName;
  onChange?: (value: boolean) => void;
};

export const FormikToggleField = <TFormikValues,>({
  onChange,
  ...props
}: Props<TFormikValues>): JSX.Element => {
  const field = props.formik.getFieldProps(props.name);
  const handleChange = (value: boolean) => {
    field.onChange({
      target: {
        name: field.name,
        value,
      },
    });

    onChange?.(value);
  };

  return <Toggle {...props} onChange={handleChange} value={field.value} />;
};
